<template>
  <v-container
    :id="`components-layout-${id}`"
    :class="main_color"
    fluid
    pa-0
    :style="`--nav-bar: ${widthNavBar}`">
    <div
      class="content pl-8"
      :class="{'with_footer': with_footer, 'no-scroll': noWrap}">
      <div
        id="content-container"
        class="flex flex-wrap"
        :class="[main_color, 'align-content-start', 'content-container', 'py-4 px-0']">
        <div
          data-qa="breadcrumbs">
          <slot name="breadcrumbs"/>
        </div>
        <div
          class="main-content">
          <slot name="main_content"/>
        </div>
      </div>
      <div
        v-if="useCollapse"
        class="nav-bar-btn"
        :class="{'show-navBar': !mini}"
        data-qa="btn-collapse-navBar"
        @click="changeNavbarState(!mini)">
        <sIcon
          class="my-auto mx-auto"
          :rotate="mini ? 0 : 180"
          size="10"
          type="double-arrow"/>
      </div>
      <div
        class="nav-bar sticky pt-0 main__light_green"
        :class="{'is-small': mini}"
        data-qa="nav-bar"
        :style="`--nav-bar: ${widthNavBar}`">
        <slot
          :mini="mini"
          name="nav_bar"/>
      </div>
    </div>
    <ComponentsTemplatesFooter v-if="with_footer">
      <slot name="footer"/>
    </ComponentsTemplatesFooter>
  </v-container>
</template>
<script>
//import { eventBus } from '@/main'
import ComponentsTemplatesFooter from 'pages/templates/ComponentsTemplatesFooter.vue'
import { storageMixin } from 'mixins'
import displaySize from 'mixins/display-size'

export default {
  name: 'componentsLayoutWithNavbar',
  mixins: [ storageMixin, displaySize ],
  data() {
    return {
      mini: false,
      useCollapse: true,
    }
  },
  methods: {
    changeNavbarState(result) {
      if (!this.useCollapse) {
        this.mini = false
        return
      }
      this.mini = result
      this.$_savePropToDBStorage('layoutNavbarMini', this.mini)
    },
    changeState(state) {
      this.useCollapse = !state
      if (state) {
        this.mini = false
      }
    }
  },
  computed: {
    widthNavBar() {
      const fullWidth = this.breakpoint.width < 375 ? this.breakpoint.width - 45 : 340
      return this.mini ? '15px' : `${fullWidth}px`
    }
  },
  mounted() {
    this.$root.$on('modalState', this.changeState)
    if (this.breakpoint.smAndDown) {
      this.changeNavbarState(true)
    } else {
      this.$_getPropFromDBStorage('layoutNavbarMini', false)
        .then((result) => {
          this.changeNavbarState(result || result === 'true')
        })
    }

    /*this.$_getPropFromDBStorage('layoutNavbarMini_tour', false)
      .then(async (layoutNavbarMiniTour) => {
        if (layoutNavbarMiniTour) { return }
        const tour = [
          {
            title: 'Зверніть увагу',
            text: 'Ми додали новий функціонал',
            step: 1,
            float: true,
            position: 'middle-right'
          },
          {
            dataKey: 'btn-collapse-navBar',
            title: 'Кнопка згортання блока',
            text: 'Цією кнопкою можна згорнути або розгорнути правий блок </br><b>для зручності перегляду основної інформації</b>',
            step: 2,
            position: 'middle-left'
          },
          {
            dataKey: 'nav-bar',
            text: 'Статус блоку зберігається <b>на всіх сторінках</b>',
            step: 3,
            position: 'auto'
          },
          {
            dataKey: 'nav-bar',
            text: 'Для мобільних пристроїв блок буде згорнутий при завантаженні сторінки <b>завжди</b>',
            step: 4,
            position: 'left'
          }
        ]
        eventBus.$emit('startTour', tour)
        this.$nextTick(async () => {
          await this.$_savePropToDBStorage('layoutNavbarMini_tour', true)
        })
      })*/
  },
  beforeDestroy() {
    this.$root.$off('modalState', this.changeState)
  },
  props: {
    id: String,
    main_color: String,
    with_footer: Boolean,
    noWrap: {
      type: Boolean,
      default: false
    },
  },
  components: {
    ComponentsTemplatesFooter
  }
}
</script>
<style lang="scss" scoped>
.nav-bar-btn {
  position: absolute;
  right: 0px;
  top: 10px;
  z-index: 10;
  background: var(--v-secondary__green_chosen-base);
  width: 30px;
  height: 30px;
  line-height: 1;
  border-radius: 50px;
  cursor: pointer;
  display: flex;
  transition: all 0.25s;
  border: 2px solid var(--v-main__green-base) !important;
  &.show-navBar {
    right: calc(var(--nav-bar) - 15px);
  }
}
.content {
  display: flex;
}
.content-container {
  width: calc(100% - var(--nav-bar));
  max-height: 100vh;
  overflow-y: auto;
  padding-right: 40px !important;
  .main-content {
    line-height: 1.5;
    color: var(--text-color) !important;
    display: flex;
    flex-wrap: wrap;
    flex: 1 1 100%;
    max-width: 100% !important;
    width: calc(100% - var(--nav-bar));
  }
}
.content.with_footer {
  height: calc(100vh - 72px);
  width: 100vw;
  overflow: auto;
  &.no-scroll {
    overflow: hidden;
  }
}
.sticky {
  z-index: 6;
  position: sticky;
  top: 0
}
.nav-bar {
  min-width: var(--nav-bar) !important;
  max-width: var(--nav-bar) !important;
  width: var(--nav-bar) !important;
  height: 100vh !important;
  max-height: 100% !important;
  overflow: hidden;
  transition: all 0.25s;
  right: 0;
  &.is-small {
    border-left: 2px solid #b0dbd8 !important;
  }
}
</style>
